export const SCHOOL_MODES = {
  SCHOOL: 0,
  SUMMER_SCHOOL: 1,
}
